import React, {ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {getHasGranularOfflineIndication} from '../../../libs/shared/core/src/store/featureFlags/featureFlagsSelectors';
import {Icon} from '../../../libs/shared/ui/src/components/icon/icon';
import {TooltipCoordinator} from '../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {VisuallyHidden} from '../../../libs/shared/ui/src/components/visuallyHidden/visuallyHidden';
import {center} from '../../../libs/shared/ui/src/styles/mixins';
import {UserThemeConsumer} from '../../../libs/shared/ui/src/theme/userThemeConsumer';
import {useAppSelector} from '../../helpers/appReduxHelpers';

/*
 * Props.
 */

interface InboxesOfflineIndicatorProps {
  className?: string;
  isOffline: boolean;
  renderTooltip?: () => ReactNode;
}

/*
 * Styles.
 */

const StyledOfflineTooltipCoordinator = styled(TooltipCoordinator)`
  flex: none;
  ${center()}
`;

/*
 * Component.
 */

export const InboxesOfflineIndicator = (props: InboxesOfflineIndicatorProps) => {
  const hasGranularOfflineIndication = useAppSelector(getHasGranularOfflineIndication);

  if (!props.isOffline || !hasGranularOfflineIndication) {
    return null;
  }

  return (
    <UserThemeConsumer>
      {(theme) => (
        <StyledOfflineTooltipCoordinator className={props.className} render={props.renderTooltip}>
          <Icon name="offlineFilledSmall" color={theme.greys.shade60} />
          <VisuallyHidden>
            <Trans id="inboxes-offline-indicator">Offline</Trans>
          </VisuallyHidden>
        </StyledOfflineTooltipCoordinator>
      )}
    </UserThemeConsumer>
  );
};
